import { ShoppingCart, Wrench, Rocket, Building2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const WebsiteTypesSection = () => {
  const { t } = useLanguage();
  const types = [
    {
      icon: ShoppingCart,
      title: t('websiteTypes.ecommerce.title'),
      description: t('websiteTypes.ecommerce.desc'),
      identify: t('websiteTypes.ecommerce.identify'),
      gradient: "from-accent to-accent"
    },
    {
      icon: Wrench,
      title: t('websiteTypes.services.title'), 
      description: t('websiteTypes.services.desc'),
      identify: t('websiteTypes.services.identify'),
      gradient: "from-accent to-accent"
    },
    {
      icon: Rocket,
      title: t('websiteTypes.startups.title'),
      description: t('websiteTypes.startups.desc'),
      identify: t('websiteTypes.startups.identify'),
      gradient: "from-accent to-accent"
    },
    {
      icon: Building2,
      title: t('websiteTypes.established.title'),
      description: t('websiteTypes.established.desc'),
      identify: t('websiteTypes.established.identify'),
      gradient: "from-accent to-accent"
    }
  ];

  return (
    <section id="website-types" className="py-12 md:py-16 lg:py-20 bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-outline text-primary mb-4 md:mb-6 uppercase px-2" style={{ fontWeight: 900 }}>
            {t('websiteTypes.title').split(' ').slice(0, 2).join(' ')}{' '}
            <span className="relative inline-block">
              <span className="relative z-10">{t('websiteTypes.title').split(' ').slice(2).join(' ')}</span>
              <span 
                className="absolute bottom-2 left-0 right-0 h-4 -rotate-1 -z-0"
                style={{
                  backgroundColor: 'hsl(11, 86%, 55%)',
                  background: 'linear-gradient(104deg, rgba(239, 106, 55, 0) 0.9%, rgba(239, 106, 55, 1) 2.4%, rgba(239, 106, 55, 0.6) 5.8%, rgba(239, 106, 55, 0.1) 93%, rgba(239, 106, 55, 0.8) 96%, rgba(239, 106, 55, 0) 98%), linear-gradient(183deg, rgba(239, 106, 55, 0) 0%, rgba(239, 106, 55, 0.3) 7.9%, rgba(239, 106, 55, 0) 15%)'
                }}
              />
            </span>
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto font-medium text-center px-2">
            {t('websiteTypes.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
          {types.map((type) => (
            <div 
              key={type.title}
              className="bg-card rounded-2xl p-5 md:p-6 lg:p-8 shadow-elegant hover:shadow-accent transition-all duration-300 border border-border/50 group"
            >
              {/* Identifikačný tag */}
              <div className="mb-4">
                <span className="inline-block bg-accent/10 text-accent text-sm font-medium px-3 py-1 rounded-full">
                  {type.identify}
                </span>
              </div>

              {/* Icon with gradient background */}
              <div className="mb-6">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center bg-gradient-to-br ${type.gradient} group-hover:scale-110 transition-transform`}>
                  <type.icon className="w-8 h-8 text-white" />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-display font-semibold text-card-foreground mb-4 uppercase">
                {type.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-lg">
                {type.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WebsiteTypesSection;